<script>
    export let tic;
</script>
<svg
                class={tic}
                width="24"
                height="24"
                viewBox="0 0 24 24"
                stroke-width="2"
                stroke="currentColor"
                fill="none"
                stroke-linecap="round"
                stroke-linejoin="round"
              >
                <path stroke="none" d="M0 0h24v24H0z" />
                <circle cx="18" cy="16" r="3" />
                <line x1="21" y1="13" x2="21" y2="19" />
                <path d="M3 19l5 -13l5 13" />
                <line x1="5" y1="14" x2="11" y2="14" />
              </svg>